import React from 'react'
import MediaQuery from 'react-responsive';

import {STATIC_ROOT} from '../../constants';
import LocalizedNavLink from '../router/LocalizedNavLink';

import { MODAL_TYPE_LOGIN } from '../../services/modal/constants';

import FooterComponent from '../footer/FooterComponent';

import './Home.scss'

const NotAuthenticated = ({ i18nHome, showModal }) => {

    const {
        TITLE,
        DESCRIPTION,
        RATING,
        TUTORIAL,
        DISCOVER,
        REVIEWS,
        BOTTOM
    } = i18nHome

    const cards = [
        {
            image: "favorites",
            title: DISCOVER.CARDS.FIRST.TITLE,
            text: DISCOVER.CARDS.FIRST.TEXT
        },
        {
            image: "sponsorship",
            title: DISCOVER.CARDS.SECOND.TITLE,
            text: DISCOVER.CARDS.SECOND.TEXT
        },
        {
            image: "payment",
            title: DISCOVER.CARDS.THIRD.TITLE,
            text: DISCOVER.CARDS.THIRD.TEXT
        }
    ]

    const reviewsList = [
        [
            {
                name: REVIEWS.LIST.FIRST.NAME,
                content: REVIEWS.LIST.FIRST.CONTENT
            },
            {
                name: REVIEWS.LIST.SECOND.NAME,
                content: REVIEWS.LIST.SECOND.CONTENT
            }
        ],
        [
            {
                name: REVIEWS.LIST.THIRD.NAME,
                content: REVIEWS.LIST.THIRD.CONTENT
            },
            {
                name: REVIEWS.LIST.FOURTH.NAME,
                content: REVIEWS.LIST.FOURTH.CONTENT
            }
        ],
        [
            {
                name: REVIEWS.LIST.FIFTH.NAME,
                content: REVIEWS.LIST.FIFTH.CONTENT
            }
        ]
    ]

    const storeLinks = {
        apple: "https://apps.apple.com/nl/app/ebuyclub-cashback-promo/id933164557",
        google: "https://play.google.com/store/apps/details?id=com.ebuyclub",
        huawei: "https://appgallery.huawei.com/app/C102480415"
    }

    const trackedLink = "https://app.adjust.com/16krdci6"

    return (
        <div>
            <div className="not-auth-container">
                <div className="header">
                    <LocalizedNavLink to="/" className="logo">
                        <img src={`${STATIC_ROOT}/logo.svg`} width="141px" height="50px" alt="ebc-logo" />
                    </LocalizedNavLink>
                    <div className="account" onClick={() => showModal(MODAL_TYPE_LOGIN)}>
                        <img src={`${STATIC_ROOT}/account.svg`} width="45px" height="45px" alt="account-logo" />
                    </div>
                </div>
                <div className="top-banner">
                    <div className="top-container">
                        <h1>{TITLE}</h1>
                        <p className="subtitle">{DESCRIPTION}</p>
                        <MediaQuery query="(max-width: 641px)">
                            {matches => (
                                <div className="stores">
                                    <a href={matches ? trackedLink : storeLinks.apple} target="_blank">
                                        <img src={`${STATIC_ROOT}/home/app-store.svg`} width="200px" height="55px" alt="app-store-ebc" />
                                    </a>
                                    <a href={matches ? trackedLink : storeLinks.google} target="_blank">
                                        <img src={`${STATIC_ROOT}/home/google-play.svg`} width="200px" height="55px" alt="google-play-ebc" />
                                    </a>
                                    <a href={storeLinks.huawei} target="_blank">
                                        <img src={`${STATIC_ROOT}/home/huawei.svg`} width="200px" height="55px" alt="huawei-store-ebc" />
                                    </a>
                                </div>
                            )}
                        </MediaQuery>
                        <div className="rating">
                            <p className="rating-text">{RATING.RATED}</p>
                            <img src={`${STATIC_ROOT}/home/rating.svg`} width="126px" height="24px" alt="rating-ebc" />
                            <p className="rating-text">{RATING.USERS}</p>
                        </div>
                    </div>
                    <img src={`${STATIC_ROOT}/home/app-top.png`} width="422px" height="550px" alt="app-ebc-visual" />
                </div>
                <div className="tutorial">
                    <h2>{TUTORIAL.TITLE}</h2>
                    <MediaQuery query="(max-width: 820px)">
                        {matches =>
                            (<div className="cashback">
                                {!matches && (<img src={`${STATIC_ROOT}/home/app-cashback.png`} width="410px" height="521px" alt="app-ebc-cashback" />)}
                                <div className="cashback-details">
                                    <img src={`${STATIC_ROOT}/home/icon-cashback.svg`} width="67px" height="67px" alt="cashback-icon" />
                                    <h3>{TUTORIAL.CASHBACK.TITLE}</h3>
                                    <p>{TUTORIAL.CASHBACK.DETAILS}</p>
                                </div>
                                {matches && (<img src={`${STATIC_ROOT}/home/app-cashback.png`} width="410px" height="521px" alt="app-ebc-cashback" />)}
                            </div>)
                        }
                    </MediaQuery>
                    <div className="cashback">
                        <div className="cashback-details">
                            <img src={`${STATIC_ROOT}/home/icon-jackpot.svg`} width="67px" height="67px" alt="jackpot-icon" />
                            <h3>{TUTORIAL.JACKPOT.TITLE}</h3>
                            <p>{TUTORIAL.JACKPOT.DETAILS}</p>
                        </div>
                        <img src={`${STATIC_ROOT}/home/app-jackpot.png`} width="410px" height="521px" alt="app-ebc-cashback" />
                    </div>
                    <MediaQuery query="(max-width: 820px)">
                        {matches =>
                            (<div className="cashback">
                                {!matches && (<img src={`${STATIC_ROOT}/home/app-gift-cards.png`} width="410px" height="521px" alt="app-ebc-cashback" />)}
                                <div className="cashback-details">
                                    <img src={`${STATIC_ROOT}/home/icon-gift-cards.svg`} width="67px" height="67px" alt="cashback-icon" />
                                    <h3>{TUTORIAL.GIFT_CARDS.TITLE}</h3>
                                    <p>{TUTORIAL.GIFT_CARDS.DETAILS}</p>
                                </div>
                                {matches && (<img src={`${STATIC_ROOT}/home/app-gift-cards.png`} width="410px" height="521px" alt="app-ebc-cashback" />)}
                            </div>)
                        }
                    </MediaQuery>
                </div>
                <div className="discover-reviews">
                    <h2>{DISCOVER.TITLE}</h2>
                    <div className="cards-container">
                        {cards.map(({image, title, text}, index) => (
                            <div className="card" key={index}>
                                <img src={`${STATIC_ROOT}/home/${image}.png`} width="335px" height="274px" alt={`card-${image}`} />
                                <h4>{title}</h4>
                                <p>{text}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="discover-reviews">
                    <h2>{REVIEWS.TITLE}</h2>
                    <div className="cards-container">
                        {reviewsList.map((reviews, index) => (
                            <div className="reviews-container" key={index}>
                                {reviews.map(({name, content}, index) => (
                                    <div className="review" key={index}>
                                        <img src={`${STATIC_ROOT}/home/stars.svg`} width="126px" height="24px" alt="ebc-stars-review" />
                                        <p className="review-text">{content}</p>
                                        <span className="pseudo">{name}</span>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="bottom-actions">
                    <img src={`${STATIC_ROOT}/home/ebc.svg`} width="67px" height="67px" alt="ebc-icon" />
                    <h5>{BOTTOM.TITLE}</h5>
                    <p>{BOTTOM.STORES}</p>
                    <MediaQuery query="(max-width: 641px)">
                        {matches => (
                            <div className="stores">
                                <a href={matches ? trackedLink : storeLinks.apple} target="_blank">
                                    <img src={`${STATIC_ROOT}/home/app-store.svg`} width="200px" height="55px" alt="app-store-ebc" />
                                </a>
                                <a href={matches ? trackedLink : storeLinks.google} target="_blank">
                                    <img src={`${STATIC_ROOT}/home/google-play.svg`} width="200px" height="55px" alt="google-play-ebc" />
                                </a>
                                <a href={storeLinks.huawei} target="_blank">
                                    <img src={`${STATIC_ROOT}/home/huawei.svg`} width="200px" height="55px" alt="huawei-store-ebc" />
                                </a>
                            </div>
                        )}
                    </MediaQuery>
                </div>
            </div>
            <FooterComponent />
        </div>
    );
};

export default NotAuthenticated



// WEBPACK FOOTER //
// ./src/components/home/not-authenticated.jsx